import React from 'react';

export interface GsLayoutProps {
  header: React.ReactNode;
  sidebar?: React.ReactNode;
  mobileNav?: React.ReactNode;
  children: React.ReactNode;
}

export function GsLayout({ header, sidebar, mobileNav, children }: GsLayoutProps) {
  const mainPadBottom = mobileNav ? 'pb-20 md:pb-0' : '';

  return (
    <div className="flex h-screen overflow-hidden bg-white dark:bg-slate-900">
      {sidebar}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        {header}
        {/* Canvas de page = token bg-page (#fbfbfb, plus pâle que slate-50 — cartes bg-white respirent) — dark:bg-slate-900. MASTER-DS-STANDARD-VISUEL-GLOBAL 2026-06-17 (succède à MASTER-DS-POLISH-PASS qui posait slate-50). */}
        <main
          className={`min-h-0 flex-1 overflow-auto bg-page dark:bg-slate-900 px-4 py-5 sm:px-6 sm:py-6 ${mainPadBottom}`}
        >
          {children}
        </main>
      </div>
      {/* mobileNav : composant autonome (fixed, md:hidden, safe area) — ex. MobileBottomNav */}
      {mobileNav}
    </div>
  );
}
